import { BaseMark } from './base/BaseMark';

export class Strikethrough extends BaseMark {
  constructor() {
    super('strikethrough');
  }

  get schema() {
    return {
      parseDOM: [{ tag: 's' }],
      toDOM() {
        return ['s', 0] as const;
      },
    };
  }
}
